export default {
  // eslint-disable-line
  init() {
    // JavaScript to be fired on the about us page
    const ourTeamSingleCard = document.querySelectorAll('.our-team-single-card');

    ourTeamSingleCard.forEach((e, idx) => {
      e.addEventListener('click', () => {
        if (e.classList.contains('active-flex')) {
            e.classList.remove('active-flex');
        }
        else {
          ourTeamSingleCard.forEach((element) => {
            element.classList.remove('active-flex');
          });
          ourTeamSingleCard[idx].classList.add('active-flex');
          scrollIntoViewWithOffset(ourTeamSingleCard[idx], 120);
        }
      })
    });

    const scrollIntoViewWithOffset = (selector, offset) => {
      window.scrollTo({
        behavior: 'smooth',
        top:
          selector.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js